// import "./static/css/style.min.css";
// import "./static/css/additional.min.css";
// import "./static/css/animate.css";
// import "./static/css/responsive.css";
// import "odometer/themes/odometer-theme-default.css";
// import "./static/bootstrap/css/bootstrap.min.css";

import "odometer/themes/odometer-theme-default.css";
